const { sumBy, uniq, mapValues, range, pickBy, findKey, sortBy, isEmpty, } = require('lodash');

const { entries } = Object;

const fields = () => {
  return {
    inboundDate: {
      type: 'date',
      label: '入庫日',
      validations: {
        required: v => v != null,
      },
    },
  };
};

const itemFields = ({ products = [], }) => {
  return {
    productId: {
      type: 'select',
      label: '商品',
      options: products.map(_ => ({ label: `[${_.sku}] ${_.name}`, value: _.id })),
      validations: {
        required: v => v != null,
      },
    },
    quantity: {
      type: 'integer',
      label: '数量',
      validations: {
        greaterThan0: v => v == null || v > 0,
      },
    },
    amount: {
      type: 'integer',
      label: '商品原価',
      validations: {
        greaterThan0: v => v == null || v > 0,
      },
    },
  };
};

exports.fields = fields;
exports.itemFields = itemFields;
